export const defaultState = {
  user: {},
  company: {
    all: [],
    selected: null,
    credit: {},
  },
  create_camp_general: {
    currentPanel: 0,
    locations: [],
    interests: [],
    defaultSelectBoxData: {
      campaignobjective: [],
      influencersource: [],
      location: [],
      gender: [],
      age: [],
      topics: [],
      location: [],
      language: [],
      influencerListSet: [],
    },
  },
  campDefSet: {
    brand: '',
    campaignid: '',
    name: '',
    objective: '',
    platform: '',
    budget: 0,
    influencerscount: 0,
    influencersettings: {},
    startdate: null,
    enddate: null,
    deliverables: [],
    brief: '',
    thingstoavoid: '',
    hashtags: [],
    keywords: [],
    mentions: [],
    referencelink: [],
  },
  create_camp_draft: {},
  chat_general: {},
  // influs only
  tOauthData: {
    complete: false,
  },
};
